import { useCallback } from 'react';

const HEADER_HEIGHT = 72;

export function useScrollTo() {
  const scrollTo = useCallback((anchorId: string) => {
    const el = document.getElementById(anchorId);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_HEIGHT;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  return scrollTo;
}

export { HEADER_HEIGHT };